<template>
  <el-col :span="12" class="flexbox">
    <form-item
      :label="$t('CampaignForm_ConsentPreferenceSetup_SelectPreference')"
      class="preference-select"
    >
      <el-select
        ref="preferenceSelect"
        v-model="value.event_title"
        filterable
        clearable
        :loading="loading"
        :placeholder="
          $t('CampaignForm_ConsentPreferenceSetup_SelectPreference_Placeholder')
        "
      >
        <el-option-group>
          <el-option
            key="any_preference"
            :label="$t('CampaignForm_Events_Event_Consent_Preference_Any')"
            :value="'0'"
          >
            {{ $t('CampaignForm_Events_Event_Consent_Preference_Any') }}
          </el-option>
        </el-option-group>
        <el-option-group>
          <el-option
            v-for="preference in preferences"
            :key="preference.name"
            :label="getTruncatedName(preference.name)"
            :value="preference.name"
          >
            {{ preference.name }}
          </el-option>
        </el-option-group>
      </el-select>
    </form-item>
  </el-col>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import FormItem from '@/common/components/form/FormItem'
import { RestApiPaginator } from '@/core/utils/RestApiPaginator'
import { ConsentChannels } from '@/modules/profiles/enum/ConsentChannelEnum'

export default {
  name: 'SystemConsentPreferenceSetup',
  components: { FormItem },
  props: {
    value: {
      required: true
    }
  },

  data() {
    return {
      preferences: [],
      ConsentChannels,
      loading: false,
      maxNameCharacters: 50
    }
  },

  mounted() {
    this.fetchConsentPreferencesRemote()
    this.$nextTick(() => {
      this.calculateMaxNameCharacters()
    })
  },

  methods: {
    fetchConsentPreferencesRemote() {
      this.loading = true
      new RestApiPaginator(
        projectEndpoint({
          method: 'get',
          url: `consent-subscription-preferences`,
          params: {
            sort: 'name'
          }
        })
      )
        .fetchAllPages()
        .then(data => {
          this.preferences = data
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getTruncatedName(name) {
      const truncatedName =
        name.length > this.maxNameCharacters
          ? name.substring(0, this.maxNameCharacters) + '...'
          : name
      return `${truncatedName}`
    },

    calculateMaxNameCharacters() {
      const el = this.$refs.preferenceSelect
      if (el) {
        const width = el.$el.offsetWidth
        this.maxNameCharacters = Math.floor(width / 10) - 11
      }
    }
  },
  computed: {
    systemChannels() {
      return Object.values(ConsentChannels)
    },
    parsedAvailablePreferences() {
      return this.preferences.map(channel => {
        if (channel.hasOwnProperty('preferences')) {
          channel.preferences.map(preference => {
            preference.id = preference.id.toString()
            return preference
          })
        }
        return channel
      })
    }
  }
}
</script>

<style scoped lang="scss">
.flexbox {
  display: flex;
  .preference-select {
    width: 100%;
  }
}
.preference-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: auto;
}
.preference-option {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/setup/SystemConsentPreferenceSetup.vue